;(() => {
  const positionClasses =
    "tooltip_top tooltip_left tooltip_right tooltip_center"

  class Tooltip {
    constructor(parent) {
      this.parent = parent
      this.arrows = null
      this.tooltip = this.parent.find(".tooltip")

      if (this.tooltip.data("template")) {
        const templateId = this.tooltip.data("template")
        const extraContent = this.tooltip.hasClass("tooltip_glossary")
          ? Tooltip.glossaryBadgeHtml
          : ""
        const initedTemplateTooltip = $(
          `body > .tooltip[data-template='${templateId}']`,
        )
        if (initedTemplateTooltip.length > 0) {
          this.tooltip.remove()
          this.tooltip = initedTemplateTooltip
        } else {
          let tooltipContent = null
          try {
            tooltipContent = document.getElementById(templateId).innerHTML
          } catch (error) {
            tooltipContent = "[data missing]"
            Bugsnag.notify(`Glossary term template missing: ${templateId}`)
          }
          this.tooltip.html(extraContent + tooltipContent)
          this.tooltip.appendTo(document.body)
        }
      } else {
        this.tooltip.appendTo(document.body)
      }

      this.openDelay = null
      this.openDelayDuration = this.tooltip.hasClass("tooltip_nodelay")
        ? 0
        : 100

      this.closeDelay = null
      this.closeDelayDuration = this.tooltip.hasClass("tooltip_hover") ? 100 : 0

      if (Detector.phoneOrTablet) {
        if (!this.parent.hasClass("tooltip--container_clickable")) {
          this.parent.on("click", (e) => this.toggle(e))
        }
      } else {
        this.parent.on("mouseenter", (e) => {
          this.show(e)
          if (this.tooltip.hasClass("tooltip_hover")) {
            this.tooltip.off("mouseenter")
            this.tooltip.off("mouseleave")
            this.tooltip.on("mouseenter", (event) => this.show(event))
            this.tooltip.on("mouseleave", (event) => this.hide(event))
          }
        })

        this.parent.on("mouseleave", (e) => this.hide(e))
        if (!this.parent.hasClass("tooltip--container_clickable")) {
          this.parent.on("click", (event) => {
            event.stopPropagation()
            event.preventDefault()
          })
        }
      }

      this.parent[0].tooltip_instance = this
      this.tooltip[0].tooltip_parent = this.parent[0]

      this.clearTimeouts = this.clearTimeouts.bind(this)
      this.show = this.show.bind(this)
      this.hide = this.hide.bind(this)
      this.toggle = this.toggle.bind(this)
      this.setPosition = this.setPosition.bind(this)
    }

    clearTimeouts() {
      clearTimeout(this.openDelay)
      clearTimeout(this.closeDelay)
    }

    show(event) {
      // cash-dom binds `.on("mouseenter")` to the native `mouseover` event, so
      // hover-driven shows arrive as `mouseover` (not `mouseenter`). Treat both
      // as hover so this works whether the event came from cash or a direct call.
      const isHover =
        event?.type === "mouseover" || event?.type === "mouseenter"

      // A programmatic scroll moves content under a stationary cursor, firing
      // synthetic mouseover events. Ignore those so tooltips don't pop open
      // mid-scroll (e.g. after the search "Change" button scrolls to top).
      if (isHover && Viewport.isScrolling?.()) {
        return
      }

      if (!isHover) {
        event.stopPropagation()
        event.preventDefault()
      }

      this.clearTimeouts()
      this.openDelay = setTimeout(() => {
        const label = this.tooltip.data("label")
        if (label) Activity.track("tooltip", "show", label)
        const template = this.tooltip.data("template")
        if (template)
          Activity.track("term", "show", template, this.parent.text())
        this.tooltip.addClass("tooltip_hidden tooltip_active")
        this.setPosition()
        this.debouncedSetPosition = HB.debounce(() => {
          this.setPosition()
        }, 30)
        $(window).on("scroll.tooltip", this.debouncedSetPosition)
        this.tooltip.removeClass("tooltip_hidden")
      }, this.openDelayDuration)
    }

    hide(event) {
      event.stopPropagation()
      event.preventDefault()
      this.arrows?.remove()
      $(window).off("scroll.tooltip", this.debouncedSetPosition)

      this.clearTimeouts()
      this.closeDelay = setTimeout(() => {
        Tooltip.hide(this.tooltip)
      }, this.closeDelayDuration)
    }

    toggle(event) {
      if (this.tooltip.hasClass("tooltip_active")) {
        this.hide(event)
      } else {
        this.show(event)
      }
    }

    setPosition() {
      if (!this.positioner) {
        if (this.tooltip.hasClass("tooltip_horizontal")) {
          this.positioner = new PositionerHorizontal(this.parent, this.tooltip)
        } else {
          const title = this.parent.find(".tooltip--title")
          const anchor = title.length > 0 ? title : this.parent
          this.positioner = new PositionerVertical(anchor, this.tooltip)
        }
      }
      const positionerData = this.positioner.get()
      requestAnimationFrame(() => {
        this.tooltip.css(positionerData.tooltip_position)
        this.tooltip
          .removeClass(positionClasses)
          .addClass(positionerData.tooltip_class.join(" "))
        const transformOrigin = Tooltip.transformOrigin(
          positionerData,
          this.tooltip,
        )
        this.tooltip.css({
          "--tooltip-transform-origin-x": transformOrigin.x,
          "--tooltip-transform-origin-y": transformOrigin.y,
        })

        if (!this.tooltip.hasClass("tooltip_glossary")) {
          this.tooltip.prepend('<div class="tooltip-arrow-front"></div>')
        }
        this.tooltip.prepend('<div class="tooltip-arrow-back"></div>')
        this.arrows = this.tooltip.find(
          ".tooltip-arrow-front, .tooltip-arrow-back",
        )
        this.arrows.css(positionerData.arrows_position)
      })
    }

    static hide(tooltip) {
      tooltip.removeClass(`tooltip_active ${positionClasses}`)
    }

    static init() {
      requestAnimationFrame(() => {
        const elements = document.querySelectorAll(
          ".tooltip--container:not([inited])",
        )
        if (elements.length > 0) {
          const $elements = $(elements)
          $elements.attr("inited", true)
          $elements.each(function () {
            if (!this.tooltip_instance) new Tooltip($(this))
          })
        }
        Tooltip.garbageCollector()
      })
    }

    static garbageCollector() {
      $("body > .tooltip").each(function () {
        const parentExists = document.body.contains(this.tooltip_parent)
        if (!parentExists && !this.dataset.template) {
          $(this).remove()
        }
      })
    }

    static getContainer(target) {
      let container = []
      if (target.hasClass("tooltip--container")) {
        container = target
      } else if (target.closest(".tooltip--container").length > 0) {
        container = target.closest(".tooltip--container")
      }
      return container
    }

    static getTooltip(container) {
      return container[0].tooltip_instance.tooltip
    }

    static transformOrigin(positionerData, tooltip) {
      const tooltipClass = positionerData.tooltip_class || []
      const isHorizontal = tooltip?.hasClass("tooltip_horizontal")

      if (isHorizontal) {
        return {
          x: tooltipClass.includes("tooltip_left") ? "right" : "left",
          y: "50%",
        }
      }

      return {
        x: "50%",
        y: tooltipClass.includes("tooltip_top") ? "bottom" : "top",
      }
    }
  }

  class Positioner {
    constructor(anchor, tooltip) {
      this.anchor = anchor
      this.tooltip = tooltip
    }

    anchorEdges() {
      const edges = this.anchor.offset()
      edges.right = edges.left + this.anchor.outerWidth()
      edges.bottom = edges.top + this.anchor.outerHeight()
      return edges
    }
  }

  class PositionerVertical extends Positioner {
    get() {
      const tooltip_class = []
      let arrows_position = null

      const tooltipWidth = this.tooltip.outerWidth()
      let tooltipLeft
      if (this.anchorEdges().left + tooltipWidth < Viewport.right()) {
        tooltipLeft = this.anchorEdges().left
        arrows_position = {
          left: `${this.anchor.outerWidth() / 2}px`,
          right: "auto",
        }
      } else if (this.anchorEdges().right - tooltipWidth <= Viewport.left()) {
        tooltipLeft =
          this.anchorEdges().right -
          (this.anchor.outerWidth() + tooltipWidth) / 2
        tooltip_class.push("tooltip_center")
      } else {
        tooltipLeft = this.anchorEdges().right - tooltipWidth
        arrows_position = {
          left: "auto",
          right: `${this.anchor.outerWidth() / 2}px`,
        }
        tooltip_class.push("tooltip_right")
      }

      const tooltipHeight = this.tooltip.outerHeight()
      let tooltipTop
      if (this.anchorEdges().bottom + tooltipHeight < Viewport.bottom()) {
        tooltipTop = this.anchorEdges().bottom
      } else {
        tooltipTop = this.anchorEdges().top - tooltipHeight
        tooltip_class.push("tooltip_top")
      }

      tooltipTop -= HB.noscrollIOSShift()

      return {
        tooltip_position: {
          left: `${tooltipLeft}px`,
          top: `${tooltipTop}px`,
        },
        tooltip_class,
        arrows_position,
      }
    }
  }

  class PositionerHorizontal extends Positioner {
    arrowsVerticalPosition(tooltipHeight) {
      if (tooltipHeight < this.anchor.outerHeight()) {
        return 20
      } else {
        return this.anchor.outerHeight() / 2 - 4
      }
    }

    get() {
      const tooltip_class = []
      let arrows_position = null

      const tooltipWidth = this.tooltip.outerWidth()
      let tooltipLeft
      if (HB.isLTR()) {
        if (this.anchorEdges().right + tooltipWidth < Viewport.right()) {
          tooltipLeft = this.anchorEdges().right
        } else {
          tooltipLeft = this.anchorEdges().left - tooltipWidth
          tooltip_class.push("tooltip_left")
        }
      } else {
        if (this.anchorEdges().left - tooltipWidth > Viewport.left()) {
          tooltipLeft = this.anchorEdges().left - tooltipWidth
          tooltip_class.push("tooltip_left")
        } else {
          tooltipLeft = this.anchorEdges().right
        }
      }

      const tooltipHeight = this.tooltip.outerHeight()
      let tooltipTop
      if (this.anchorEdges().top + tooltipHeight < Viewport.bottom()) {
        tooltipTop = this.anchorEdges().top
        arrows_position = {
          top: `${this.arrowsVerticalPosition(tooltipHeight)}px`,
          bottom: "auto",
        }
      } else if (this.anchorEdges().bottom - tooltipHeight > Viewport.top()) {
        tooltipTop = this.anchorEdges().bottom - tooltipHeight
        arrows_position = {
          top: "auto",
          bottom: `${this.arrowsVerticalPosition(tooltipHeight)}px`,
        }
      } else {
        const marginFromBottom = 20
        const extraHeight =
          this.anchorEdges().top +
          tooltipHeight -
          Viewport.bottom() +
          marginFromBottom
        tooltipTop = this.anchorEdges().top - extraHeight
        arrows_position = {
          top: `${extraHeight + this.arrowsVerticalPosition(tooltipHeight)}px`,
          bottom: "auto",
        }
      }

      tooltipTop -= HB.noscrollIOSShift()

      return {
        tooltip_position: {
          left: `${tooltipLeft}px`,
          top: `${tooltipTop}px`,
        },
        tooltip_class,
        arrows_position,
      }
    }
  }

  $(() => {
    Tooltip.init()
    const throttleInit = HB.throttle(Tooltip.init, 200)
    const observer = new MutationObserver(throttleInit)
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
    })
  })

  $(() => {
    if (Detector.phoneOrTablet) {
      document.addEventListener(
        "touchstart",
        (e) => {
          const activeTooltip = $(".tooltip_active")
          if (activeTooltip.length < 1) return

          const isTooltipHover =
            $(e.target).hasClass("tooltip_hover") ||
            $(e.target).closest(".tooltip_hover").length > 0
          if (isTooltipHover) return

          const container = Tooltip.getContainer($(e.target))
          const tooltipToHide =
            container.length > 0
              ? activeTooltip.not(Tooltip.getTooltip(container))
              : activeTooltip

          Tooltip.hide(tooltipToHide)
        },
        { passive: true },
      )
    }
  })

  window.HB = window.HB || {}
  window.HB.Tooltip = Tooltip
  window.HB.Tooltip.glossaryBadgeHtml = $("#term--glossary-badge").html()
})()
